<template>
  <div :style="style.global">
    <router-view />
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';

import { useStyle } from '@composables/use-style';

const { colors, colorManager, fontStyle } = useStyle();

const style = ref({
  global: {
    fontFamily: fontStyle.FAMILY.PRIMARY,
    fontSize: fontStyle.SIZE.MD,
    fontWeight: fontStyle.WEIGHT.MD,
    minWidth: '100%',
    minHeight: '100vh',
    '-webkit-font-smoothing': 'antialiased',
    'moz-osx-font-smoothing': 'grayscale',
    'scroll-behavior': 'smooth',
  },
});

document.documentElement.style.backgroundColor = colors.BACKGROUND1();

watch(() => colorManager.mode, () => {
  document.documentElement.style.backgroundColor = colors.BACKGROUND1();
});
</script>

<style lang="scss">
html, body {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

* {
  box-sizing: inherit;
  /* max-width: 100%; */
}

*::before, *::after {
  box-sizing: inherit;
  /* max-width: 100%; */
}

a {
  color: inherit;
  outline: none;
  text-decoration: none;

  &:focus {
    border-radius: 0;
    outline: 1px solid gray;
  }
}
</style>
